import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import FormGuarantee from '../../../../view/FormGuarantee';
import Data from '../../../../data/StateDeedOfAbsoluteSale.json';
import converter from 'number-to-words';
import {Title, Noun, SubjectVerb, Pronoun, SingularPluralForm} from '../../../../model/Helper';
import Loading from '../../../../view/Loading';
import PaperSignatoriesForPdf from '../../../../model/PaperSignatoriesForPdf';
import PaperSignatoriesAcknowledgementForPdf from '../../../../model/PaperSignatoriesAcknowledgementForPdf';
import RequiredData from '../../../../model/RequiredData';
import PaperPartyPdf from '../../../../model/PaperPartyPdf';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class DeedOfAbsoluteSaleStep6 extends Component {

    constructor(props){
        super(props);
        this.state = Data;
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
                    RequiredData.property(this.state, this.state.formPath+"/1");
                    RequiredData.seller(this.state, this.state.formPath+"/2");
                    RequiredData.buyer(this.state, this.state.formPath+"/3");
                    RequiredData.price(this.state, this.state.formPath+"/4");
                    // Step 5 is pre-popuated

					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {
        // Data
        let p = this.state.details.property;
        let s = this.state.details.seller;
        let b = this.state.details.buyer;
        let pa = this.state.details.payment;

        /**
         * Noun / Pronoun
         */
        let nounSeller = Noun(s, "seller");
        let nounBuyer  = Noun(b, "buyer");

        let blankLine = "____________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;
        let pType = blankLine;
        if(p.type==="Condominium"){
            pType = `condominium`;
        }
        if(p.type==="Land"){
            pType = `parcel of land`;
        }
        if(p.type==="Land with Improvement"){
            pType = `parcel of land, together with its improvement`;
        }

        // Natural person variables
        let sellerName = [], 
            sellerSpouseName = [],
            sellerNationality = [],
            sellerAddress = [],
            sellerRepresentativeName = [],
            sellerRepresentativeNationality = [],
            sellerRepresentativeAddress = [],
            sellerTin = [];
        // Corporation variables
        let sellerCorporationName = [],
            sellerCorporationPrincipalPlaceOfBusiness = [],
            sellerCorporationRepresentativeName = [],
            sellerCorporationRepresentativePosition = [],
            sellerCorporationTin = [];
        s.forEach((seller, i)=>{
            sellerName[i] = (seller.sellerFname || seller.sellerMname || seller.sellerLname) ? 
                                    (seller.sellerFname+(seller.sellerMname?` ${seller.sellerMname}`:"")+(seller.sellerLname?` ${seller.sellerLname}`:"")+(seller.sellerSuffix?` ${seller.sellerSuffix}`:"")): 
                                    blankLine;
            sellerSpouseName[i] = (seller.sellerSpouseFname || seller.sellerSpouseMname || seller.sellerSpouseLname) ? 
            (seller.sellerSpouseFname+(seller.sellerSpouseMname?` ${seller.sellerSpouseMname}`:"")+(seller.sellerSpouseLname?` ${seller.sellerSpouseLname}`:"")+(seller.sellerSpouseSuffix?` ${seller.sellerSpouseSuffix}`:"")): 
            blankLine;
            sellerNationality[i] = seller.sellerNationality ? seller.sellerNationality : blankLine;
            sellerAddress[i] = seller.sellerAddress ? seller.sellerAddress :  blankLine;
            
            sellerRepresentativeName[i] = (seller.sellerRepresentativeFname || seller.sellerRepresentativeMname || seller.sellerRepresentativeLname) ? 
                                    (seller.sellerRepresentativeFname+(seller.sellerRepresentativeMname?` ${seller.sellerRepresentativeMname}`:"")+(seller.sellerRepresentativeLname?` ${seller.sellerRepresentativeLname}`:"")+(seller.sellerRepresentativeSuffix?` ${seller.sellerRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerRepresentativeNationality[i] = seller.sellerRepresentativeNationality ? seller.sellerRepresentativeNationality : blankLine;
            sellerRepresentativeAddress[i] = seller.sellerRepresentativeAddress ? seller.sellerRepresentativeAddress :  blankLine;
            sellerTin[i] = seller.sellerTin ? seller.sellerTin : "";

            sellerCorporationName[i] = seller.sellerCorporationName ? seller.sellerCorporationName : blankLine;
            sellerCorporationPrincipalPlaceOfBusiness[i] = seller.sellerCorporationPrincipalPlaceOfBusiness ? seller.sellerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            sellerCorporationRepresentativeName[i] = (seller.sellerCorporationRepresentativeFname || seller.sellerCorporationRepresentativeMname || seller.sellerCorporationRepresentativeLname) ? 
                                    (seller.sellerCorporationRepresentativeFname+(seller.sellerCorporationRepresentativeMname?` ${seller.sellerCorporationRepresentativeMname}`:"")+(seller.sellerCorporationRepresentativeLname?` ${seller.sellerCorporationRepresentativeLname}`:"")+(seller.sellerCorporationRepresentativeSuffix?` ${seller.sellerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            sellerCorporationTin[i] = seller.sellerCorporationTin ? seller.sellerCorporationTin : "";
            sellerCorporationRepresentativePosition[i] = seller.sellerCorporationRepresentativePosition ? seller.sellerCorporationRepresentativePosition : blankLine;
            return;
        });

        // Natural person variables
        let buyerName = [], 
            buyerSpouseName = [],
            buyerNationality = [],
            buyerAddress = [],
            buyerRepresentativeName = [],
            buyerRepresentativeNationality = [],
            buyerRepresentativeAddress = [],
            buyerTin = [];
        // Corporation variables
        let buyerCorporationName = [],
            buyerCorporationPrincipalPlaceOfBusiness = [],
            buyerCorporationRepresentativeName = [],
            buyerCorporationRepresentativePosition = []
        b.forEach((buyer, i)=>{
            buyerName[i] = (buyer.buyerFname || buyer.buyerMname || buyer.buyerLname) ? 
                                    (buyer.buyerFname+(buyer.buyerMname?` ${buyer.buyerMname}`:"")+(buyer.buyerLname?` ${buyer.buyerLname}`:"")+(buyer.buyerSuffix?` ${buyer.buyerSuffix}`:"")): 
                                    blankLine;
            buyerSpouseName[i] = (buyer.buyerSpouseFname || buyer.buyerSpouseMname || buyer.buyerSpouseLname) ? 
            (buyer.buyerSpouseFname+(buyer.buyerSpouseMname?` ${buyer.buyerSpouseMname}`:"")+(buyer.buyerSpouseLname?` ${buyer.buyerSpouseLname}`:"")+(buyer.buyerSpouseSuffix?` ${buyer.buyerSpouseSuffix}`:"")): 
            blankLine;
            buyerNationality[i] = buyer.buyerNationality ? buyer.buyerNationality : blankLine;
            buyerAddress[i] = buyer.buyerAddress ? buyer.buyerAddress :  blankLine;
            
            buyerRepresentativeName[i] = (buyer.buyerRepresentativeFname || buyer.buyerRepresentativeMname || buyer.buyerRepresentativeLname) ? 
                                    (buyer.buyerRepresentativeFname+(buyer.buyerRepresentativeMname?` ${buyer.buyerRepresentativeMname}`:"")+(buyer.buyerRepresentativeLname?` ${buyer.buyerRepresentativeLname}`:"")+(buyer.buyerRepresentativeSuffix?` ${buyer.buyerRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerRepresentativeNationality[i] = buyer.buyerRepresentativeNationality ? buyer.buyerRepresentativeNationality : blankLine;
            buyerRepresentativeAddress[i] = buyer.buyerRepresentativeAddress ? buyer.buyerRepresentativeAddress :  blankLine;

            buyerCorporationName[i] = buyer.buyerCorporationName ? buyer.buyerCorporationName : blankLine;
            buyerCorporationPrincipalPlaceOfBusiness[i] = buyer.buyerCorporationPrincipalPlaceOfBusiness ? buyer.buyerCorporationPrincipalPlaceOfBusiness : blankLine;
            
            buyerCorporationRepresentativeName[i] = (buyer.buyerCorporationRepresentativeFname || buyer.buyerCorporationRepresentativeMname || buyer.buyerCorporationRepresentativeLname) ? 
                                    (buyer.buyerCorporationRepresentativeFname+(buyer.buyerCorporationRepresentativeMname?` ${buyer.buyerCorporationRepresentativeMname}`:"")+(buyer.buyerCorporationRepresentativeLname?` ${buyer.buyerCorporationRepresentativeLname}`:"")+(buyer.buyerCorporationRepresentativeSuffix?` ${buyer.buyerCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            buyerTin[i] = buyer.buyerTin ? buyer.buyerTin : ""; 
            buyerCorporationRepresentativePosition[i] = buyer.buyerCorporationRepresentativePosition ? buyer.buyerCorporationRepresentativePosition : blankLine;

        });

        let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                                Number(p.price).toLocaleString() :
                                blankLine;		
        let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
                            converter.toWords(p.price) : 
                            blankLine;

        let buyersPayArray = [];
        let sellersPayArray = [];
        pa.capitalGainTax === "seller" ?
            sellersPayArray.push("capital gain tax"):
            buyersPayArray.push("capital gain tax");
        pa.documentaryStampTax === "seller" ?
            sellersPayArray.push("documentary stamp tax"):
            buyersPayArray.push("documentary stamp tax");
        pa.transferTax === "seller" ?
            sellersPayArray.push("transfer tax"):
            buyersPayArray.push("transfer tax");
        pa.registrationFee === "seller" ?
            sellersPayArray.push("registration fee"):
            buyersPayArray.push("registration fee");
        pa.notarialFee === "seller" ?
            sellersPayArray.push("notarial fee") :
            buyersPayArray.push("notarial fee");
        if(pa.hasBroker === "Yes"){
            pa.brokerCommission === "seller" ?
                sellersPayArray.push("broker's commission") :
                buyersPayArray.push("broker's commission");
        }
        pa.creditableWithholdingTax === "seller" ?
            sellersPayArray.push("creditable withholding tax") :
            buyersPayArray.push("creditable withholding tax");
        pa.valueAddedTax === "seller" ?
            sellersPayArray.push("value added tax") :
            buyersPayArray.push("value added tax");
        let sellersPay = sellersPayArray.join(", ");
        let buyersPay = buyersPayArray.join(", ");

        let surrenderCondominium = ``;
        let surrenderLand = ``;
        let surrenderLandWithImprovement = ``;
        if(p.type){
            if(p.type==="Condominium"){
                if(p.surrenderCct==="Yes"){
                    surrenderCondominium+=`<li>Owner’s Duplicate Original Copy of CCT ${p.ctn};`;
                }
                if(p.surrenderLatestTaxDeclarationOnCondominium==="Yes"){
                    surrenderCondominium+=`<li>Latest Tax Declaration on the land;`;
                }
                if(p.surrenderTaxClearanceCertificate==="Yes"){
                    surrenderCondominium+=`<li>Tax Clearance Certificate`;
                }
            }
            if(p.type==="Land"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLand+=`<li>Owner’s Duplicate Original Copy of OCT ${p.oct};`;
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLand+=`<li>Owner’s Duplicate Original Copy of TCT ${p.tct};`;
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLand+=`<li>Latest Tax Declaration on the land;`;
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLand+=`<li>Tax Clearance Certificate for the land;`;
                }
            }
            if(p.type==="Land with Improvement"){
                if(p.registrationType==="oct"){
                    if(p.surrenderOct==="Yes"){
                        surrenderLandWithImprovement+=`<li>Owner’s Duplicate Original Copy of OCT ${p.oct};`;
                    }
                }
                if(p.registrationType==="tct"){
                    if(p.surrenderTct==="Yes"){
                        surrenderLandWithImprovement+=`<li>Owner’s Duplicate Original Copy of TCT ${p.tct};`;
                    }
                }
                if(p.surrenderLatestTaxDeclarationOnLand==="Yes"){
                    surrenderLandWithImprovement+=`<li>Latest Tax Declaration on the land;`;
                }
                if(p.surrenderLatestTaxDeclarationOnImprovment==="Yes"){
                    surrenderLandWithImprovement+=`<li>Latest Tax Declaration on the improvement;`;
                }
                if(p.surrenderTaxClearanceCertificateOnLand==="Yes"){
                    surrenderLandWithImprovement+=`<li>Tax Clearance Certificate for the land;`;
                }
                if(p.surrenderTaxClearanceCertificateOnImprovement==="Yes"){
                    surrenderLandWithImprovement+=`<li>Tax Clearance Certificate on the improvement`;
                }
            }
        }

        let contract_html = `
        <style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css");
        </style>        
        <div class="pdf">
            <div class="paper">
                
                <div class="paper-title text-center">
                    Deed of Absolute Sale
                </div>

                <div class="text-uppercase">
                    <p class="no-indent">
                        KNOW ALL MEN BY THESE PRESENTS:
                    </p>
                </div>

                <div>
                    <p>
                    This Deed of Absolute Sale (hereinafter “Deed”) made and entered into this _______________ in _______________, Philippines, by and between:
                    </p>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(s, "seller")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3">- and -</div>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(b, "buyer")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3"><strong>WITNESSETH</strong>: That-</div>
                </div>

                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounSeller}</span> ${SubjectVerb(nounSeller, "is")} the absolute and registered ${SingularPluralForm(nounSeller, "owner")} of a ${pType} (hereinafter “Subject Real Property”), situated at <span class="dynamic-data text-capitalize">${pAddress}</span> and covered by <span class="dynamic-data">${title}</span>. A copy of this title is hereto attached and made an integral part hereof.
                    </p>
                </div>
                        
                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounSeller}</span> ${SubjectVerb(nounSeller, "has")} offered to sell to the <span class="text-uppercase">${nounBuyer}</span>, and the <span class="text-uppercase">${nounBuyer}</span> ${SubjectVerb(nounBuyer, "has")} agreed to purchase from the <span class="text-uppercase">${nounSeller}</span>, the Subject Real Property;
                    </p>
                </div>

                <div>
                    <p>
                        NOW THEREFORE, for and in consideration of the foregoing premises and the payment of the purchase price hereinafter specified, the <span class="text-uppercase">${nounSeller}</span> hereby sell, transfer and convey unto the <span class="text-uppercase">${nounBuyer}</span> the Subject Real Property under the terms and conditions specified below:    
                    </p>
                </div>

                <div class="section1 my-3">
                    <h5 class="my-3">SECTION 1. <u>PURCHASE PRICE</u></h5>
                    <p>
                        1.1.     The purchase price of the Subject Real Property under this Deed is <span class="dynamic-data text-uppercase">${priceText}</span> PESOS (P<span class="dynamic-data">${priceNumber}</span>) Philippine Currency (hereinafter “Purchase Price”), receipt of which is hereby acknowledged by the <span class="text-uppercase">${nounSeller}</span> from the <span class="text-uppercase">${nounBuyer}</span> to their full and complete satisfaction.  
                    </p> 
                </div>

                <div class="section2 my-3">
                        <h5 class="my-3">SECTION 2. <u>RECEIPT OF TITLE</u></h5>
                        <p>
                            2.1.     The <span class="text-uppercase">${nounBuyer}</span> hereby ${SubjectVerb(nounBuyer, "acknowledges")} receipt from the <span class="text-uppercase">${nounSeller}</span> of the following documents, to wit:
                        </p>
                        <div class="ml-5">
                            <ol type="a" class=${p.type==="Condominium"?``:`d-none`}>
                                ${surrenderCondominium}
                            </ol>
                            <ol type="a" class=${p.type==="Land"?``:`d-none`}>
                                ${surrenderLand}
                            </ol>
                            <ol type="a" class=${p.type==="Land with Improvement"?``:`d-none`}>
                                ${surrenderLandWithImprovement}
                            </ol>
                        </div>

                    </div>

                    <div class="section3 my-3">
                        <h5 class="my-3">SECTION 3. <u>WARRANTIES OF THE SELLER</u></h5>
                        <p>
                            3.1.     The <span class="text-uppercase">${nounSeller}</span> represent and warrant to the <span class="text-uppercase">${nounBuyer}</span> that:
                        </p>
                        <div class="ml-5">
                            <ol type="a">
                                <li>
                                    <span class="ucfirst">${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> ${SubjectVerb(nounSeller, "has")} all the requisite rights, power and authority to comply with the provisions of this Deed. <span class="ucfirst">${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> also ${SubjectVerb(nounSeller, "has")} the power to deliver and sell the Subject Real Property and to carry out all obligations under this Deed;
                                </li>
                                <li>
                                    <span class="ucfirst">${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)}</span> ${SubjectVerb(nounSeller, "is")} the lawful, beneficial and registered owner of the Subject Real Property;
                                </li>
                                <li>
                                    Upon execution of the Deed, the <span class="text-uppercase">${nounBuyer}</span>${nounBuyer==="buyers"?`'`:`'s`} full payment of the corresponding purchase price and delivery of the Subject Real Property by the <span class="text-uppercase">${nounSeller}</span>, the <span class="text-uppercase">${nounBuyer}</span> will receive good title to it, free and clear of all encumbrances;
                                </li>
                                <li>
                                    All the property taxes on the Subject Real Property, including interest,penalties or other tax assessments, with respect thereto, have been paid by the <span class="text-uppercase">${nounSeller}</span>. There is no pending or potential assessments for unpaid and deficiency taxes, assessments, penalties, interest which constitute or will constitute a lien or encumbrance on the Subject Real Property; and
                                </li>
                                <li>
                                    ${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} will defend the <span class="text-uppercase">${nounBuyer}</span> from any reasonable claims of lawful title made by third parties. Furthermore, ${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} ${SubjectVerb(nounSeller, "assures")} the <span class="text-uppercase">${nounBuyer}</span> that ${Pronoun("he", s[0].sellerGender, s[0].legalPersonality, nounSeller)} will compensate it for any loss sustained by reason of such claim.
                                </li>
                            </ol>
                        </div>

                    </div>

                    <div class="section4 my-3">
                        <h5 class="my-3">SECTION 4. <u>WARRANTIES OF THE <span class="text-uppercase">${nounBuyer}</span></u></h5>
                        <p>
                            4.1.     The <span class="text-uppercase">${nounBuyer}</span> represents and warrants to the <span class="text-uppercase">${nounSeller}</span> that:
                        </p>
                        <div class="ml-5">
                            <ol type="a">
                                <li>
                                    The <span class="text-uppercase">${nounBuyer}</span> ${SubjectVerb(nounBuyer, "has")} the right, power, authority and full legal capacity to comply with the provisions of this Deed. <span class="ucfirst">${Pronoun("it", b[0].buyerGender, b[0].legalPersonality, nounBuyer)}</span> ${SubjectVerb(nounBuyer, "has")} the power to buy the Subject Real Property and consummate the transaction contemplated hereby.
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="section5 my-3">
                        <h5 class="my-3">SECTION 5. <u>TAXES, FEES AND EXPENSES</u></h5>
                        <p>
                            5.1.     <span class="dynamic-data">${buyersPayArray.length>0?`The ${buyersPay}, and other`:`Other`}</span> necessary expenses connected with this Contract, the Deed of Absolute Sale and the issuance of the corresponding title for the Subject Real Property in the name of the <span class="text-uppercase">${nounBuyer}</span> shall be for the account of and paid by the <span class="text-uppercase">${nounBuyer}</span>.
                        </p>
                        <p>
                            5.2.     <span class="dynamic-data">${sellersPayArray.length>0?`The ${sellersPay}, whichever`:`Whichever`}</span> is applicable, shall be for the account of and paid by the <span class="text-uppercase">${nounSeller}</span>.
                        </p>
                        <p>
                            5.3.     The <span class="text-uppercase">${nounSeller}</span> shall update the real property taxes prior to the delivery of the Subject Real Property. From and after the said delivery, any and all real property taxes accruing on the said property shall be for the account of the <span class="text-uppercase">${nounBuyer}</span>.
                        </p>
                    </div>
                
                <br />

                <div>
                    <p>
                        IN WITNESS WHEREOF, the parties have executed this Contract on the date and in the place first above written.
                    </p>
                </div>

                <br />
                <br />

                <div>
                    ${PaperSignatoriesForPdf(s, b)}
                </div>

                <br />
                <br />
                <br />

                <div class="mt-5">
                    <div>
                        Signed in the presence of:
                    </div>
                    <table class="table-even mt-5">
                        <tr>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                        </tr>
                    </table>
                </div>


            </div>

            <div class="paper" style="page-break-before: always;">
                
                <table class="table-even">
                    <tr>
                        <td>
                            <table>
                                <tr><td><div class="pr-25px">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
                                <tr><td><div class="text-right">)S.S.</div></td></tr>
                            </table>
                        </td>
                        <td>
                        </td>
                    </tr>
                </table>

                <div class="paper-title text-center">
                    Acknowledgement
                </div>

                <div>
                    <p>
                        BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                    </p>
                </div>

                ${PaperSignatoriesAcknowledgementForPdf(s, b)}

                <div>
                    <p>
                        Known to me and to me known to be the same persons who executed the foregoing Deed of Absolute Sale consisting of [PAGES] pages, including this page where the acknowledgement is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                    </p>
                    <p>
                        WITNESS MY HAND AND SEAL in the place and on the date first above written.
                    </p>
                </div>

                <br />
                <br />
                <div class="docno">
                    Doc No. ________; <br />
                    Page No. _______; <br />
                    Book No. _______; <br />
                    Series of 20 ___. <br />
                </div>	

            </div>

        </div>`;

        let fn = "deed_of_absolute_sale_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
			title: "Your Deed of Absolute Sale Contract is ready",
			description: "Your custom Deed of Absolute Sale Contract is now ready for download"
		}
        
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((6/6)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 6/6</p>
									<Link to={this.state.formPath+"/5"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeedOfAbsoluteSaleStep6;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/deed-of-absolute-sale/DeedOfAbsoluteSaleStep6.js